<template>
	<div class="main">
		<Top />
		<div style="display: flex" class="container">
			<Menu :index="menuIndex" />
			<el-main>
				<el-tabs>
					<el-tab-pane label="路由管理">
						<el-row>
							<el-col :span="24">
								<div class="grid-content bg-purple-light" style="padding-top: 5px; padding-bottom: 5px">
									<el-form :inline="true" class="demo-form-inline" size="small">
										<el-form-item label="项目">
											<el-select v-model="search.projectId">
												<el-option :key="0" :value="0" label="全部" />
												<el-option v-for="project in all_project" :key="project.id" :label="project.name" :value="project.id"></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="关键字">
											<el-input v-model="search.search_keywrod" placeholder="" style="width: 300px" v-on:keyup.enter.native="on_search_click"></el-input>
										</el-form-item>
										<el-form-item>
											<el-button type="primary" @click="on_search_project_click">查询</el-button>
											<el-button type="primary" @click="on_create_route_click">新建路由</el-button>
											&nbsp;
										</el-form-item>
									</el-form>
								</div>
							</el-col>
						</el-row>
						<el-divider></el-divider>
					</el-tab-pane>
					<div style="display: flex">
						<el-table :data="table_data" style="width: 100%" v-loading="loading">
							<el-table-column label="ID" prop="id" width="80"></el-table-column>
							<el-table-column label="项目" width="130">
								<template slot-scope="scope">
									<el-tag>{{ get_project_name(scope.row.project) }}</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="路由规则" prop="path" width="300"></el-table-column>
							<el-table-column label="转发地址" prop="url" width="500"></el-table-column>
							<el-table-column label="妆发方式" prop="stripPrefix" width="80">
								<template slot-scope="scope">
									<el-tag>{{ scope.row.type === 0 ? '服务发现' : '反向代理' }}</el-tag>
								</template>
							</el-table-column>
							<!-- <el-table-column label="转发前缀" prop="stripPrefix" width="80">
								<template slot-scope="scope">
									<el-tag>{{ scope.row.stripPrefix === 0 ? '忽略' : '转发' }}</el-tag>
								</template>
							</el-table-column> -->
							<el-table-column label="跳过前缀" prop="stripPrefixNum" width="100"></el-table-column>
							<!-- <el-table-column label="是否重试" prop="retry" width="80">
								<template slot-scope="scope">
									<el-tag>{{ scope.row.retry === 0 ? '是' : '否' }}</el-tag>
								</template>
							</el-table-column> -->
							<el-table-column label="状态" prop="state" width="80">
								<template slot-scope="scope">
									<el-tag :type="get_state_tag_type(scope.row.state)">{{ scope.row.state === 0 ? '启用' : '禁用' }}</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="排序" prop="sort" width="100"></el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-button plain size="small" type="primary" @click="on_modify_route_click(scope.row)">编辑</el-button>
									<el-popconfirm style="margin-left: 10px" title="确认删除当前路由？" @confirm="on_delete_route_click(scope.row)">
										<el-button slot="reference" plain size="mini" type="danger">删除</el-button>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>
					</div>

					<div class="block">
						<el-pagination @size-change="page_size_change" @current-change="current_page_change" :current-page.sync="page.current_page" :page-sizes="[10, 20, 50, 100, 200]" :page-size.sync="page.page_size" layout="total, sizes, prev, pager, next, jumper" :total="page.total_size"></el-pagination>
					</div>
				</el-tabs>
			</el-main>
			<EditRoute ref="EditRouteRef" @on_create="on_create_route" @on_modify="on_modify_route" />
		</div>
	</div>
</template>

<script>
import Top from './common/Top'
import Menu from './common/Menu'
import EditRoute from './EditRoute'
export default {
	name: 'Main',
	components: { Top, Menu, EditRoute },
	data() {
		return {
			menuIndex: '1',

			loading: false,
			all_project: [],
			table_data: [],
			search: {
				projectId: 0,
				search_keywrod: ''
			},
			page: {
				current_page: 1,
				page_size: 10,
				total_size: 0
			}
		}
	},
	mounted() {
		this.load_project()
	},
	methods: {
		load_project() {
			this.axios_get('/gateway/project/all').then((res) => {
				if (res.data.code === 0) {
					this.all_project = res.data.data
					this.on_search_project_click()
				}
			})
		},
		current_page_change(current_page) {
			this.page.current_page = current_page
			this.search_route()
			console.log('current_page_change:' + this.page.current_page)
		},

		page_size_change(page_size) {
			this.page.page_size = page_size
			this.search_route()
			console.log('page_size:' + this.page.page_size)
		},
		get_project_name(projectId) {
			for (let idx in this.all_project) {
				if (this.all_project[idx].id === projectId) {
					return this.all_project[idx].name
				}
			}
			return '--'
		},
		on_search_project_click() {
			this.page.current_page = 1
			this.search_route()
		},
		search_route() {
			this.table_data = []
			this.loading = true
			this.axios_get(`/gateway/route/page?keyword=${encodeURIComponent(this.search.search_keywrod)}&project=${this.search.projectId}&page=${this.page.current_page}&limit=${this.page.page_size}`).then((res) => {
				this.loading = false
				if (res.data.code === 0) {
					this.table_data = res.data.data.list
					this.page.total_size = res.data.data.total
				}
			})
		},
		get_state_tag_type(state) {
			return state === 0 ? '' : 'danger'
		},
		on_create_route(route) {
			this.table_data.push(route)
		},
		on_modify_route(route) {
			let findIndex = this.table_data.findIndex((item) => item.id === route.id)
			this.$set(this.table_data, findIndex, route)
		},
		on_create_route_click() {
			this.$refs.EditRouteRef.init_data(this.all_project, undefined)
		},
		on_modify_route_click(route) {
			this.$refs.EditRouteRef.init_data(this.all_project, route)
		},
		on_delete_route_click(route) {
			this.axios_delete_json('/gateway/route/', { routeId: route.id }).then((res) => {
				if (res.data.code === 0) {
					let findIndex = this.table_data.findIndex((item) => item.id === route.id)
					this.$delete(this.table_data, findIndex)
				}
			})
		}
	}
}
</script>

<style scoped>
.main {
	height: 100%;
}
.container {
	height: calc(100% - 60px);
}
</style>